/* tslint:disable */

/**
 */
export class GroupBusStation {
    id?: number;
    name?: string;
    ticket_price_id?: number;
    key?: string;
    bus_stations?: string;
    direction?: number;
    parent_gr_bus_station_id?: number;
    type?: string;
    color?: string;
    created_at?: string;
}
